// extracted by mini-css-extract-plugin
export default {"tableWrap":"Table_tableWrap__RWRuX"};